import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import roadMaintenanceReportAction from './roadMaintenanceReport.action.json' with { type: 'json' }
import { roadMaintenanceExpression } from '../list/roadMaintenanceList.definition'

const roadMaintenanceReportDefinition = defineAction({
  ...roadMaintenanceReportAction,

  input: z.object({
    format: reportFormatSchema,
    filter: z.union([roadMaintenanceExpression, z.string()]).nullish(),
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default roadMaintenanceReportDefinition
